import React, { useContext } from 'react'

import AstuteRequestConfirmProceedModal from '@components/Modal/AstuteRequestConfirmProceedModal'
import useModalVisibilityControls from '@hooks/useModalVisibilityControls'
import reportImage from '@assets/images/risk-image.png'

import { AstuteContext } from '../../context'
import { parseAstuteHoldings } from './helpers'
import { Header } from './Header'
import { Content } from './Content'
import { Button } from "@UILibrary/Button"

import Routes from "@utils/routes"

export const Report = () => {
  const {
    state: { client, holdings, paths },
  } = useContext(AstuteContext)

  const [returnedHoldings, erroredHoldings, pendingHoldings] = parseAstuteHoldings(holdings)

  const modalControls = useModalVisibilityControls(false)

  return (
    <div className='astute-report-wrapper'>
      <Button
        href={Routes.clientDashboardPath({ clientId: client.id })}
        iconBefore="chevron-left"
        isLink={true}
        textOnlyVariant='primary'
        className='astute-report-wrapper--back-button'
        textOnly
      >
        Back to Client
      </Button>

      <img
        src={reportImage}
        alt='astute pending graphic'
        className='astute-report-wrapper--graphic'
      />

      <Header
        pendingHoldings={pendingHoldings}
        openModal={modalControls.openModal}
      />

      <Content
        returnedHoldings={returnedHoldings}
        pendingHoldings={pendingHoldings}
        erroredHoldings={erroredHoldings}
        totalHoldingsCount={holdings.length}
      />

      <AstuteRequestConfirmProceedModal
        show={modalControls.modalVisible}
        onClose={modalControls.closeModal}
        createAstuteRequestPath={paths.newAstuteRequestPath} />
    </div>
  )
}
